import React from "react";
import { useNavigate } from "react-router-dom";

import RaindropCard from "../raindrop-card/raindrop-card.tsx";
import RaindropTextHeading1 from "../raindrop-text-heading-1/raindrop-text-heading-1.tsx";
import RaindropTextSubtitle from "../raindrop-text-subtitle/raindrop-text-subtitle.tsx";
import RaindropClickable from "../raindrop-clickable/raindrop-clickable.tsx";

const RaindropCardGuestMode = ({ isAnonymous = false }) => {
  const navigate = useNavigate();

  if (!isAnonymous) {
    return null;
  }

  return (
    <div className="flex w-full px-4">
      <RaindropClickable
        onClick={() => navigate("/raindrop/sign-up")}
        additionalClasses="w-full"
      >
        <RaindropCard>
          <div className="flex flex-row items-center gap-2 w-full">
            <i className="fa fa-user-secret text-2xl font-black text-color-text-primary dark:text-color-dark-text-primary w-8 text-center" />
            <RaindropTextHeading1>You're in Guest Mode</RaindropTextHeading1>
          </div>
          <RaindropTextSubtitle>
            No real money will be collected until you{" "}
            <span className="font-black text-color-raindrop-primary">
              sign up.
            </span>
          </RaindropTextSubtitle>
        </RaindropCard>
      </RaindropClickable>
    </div>
  );
};

export default RaindropCardGuestMode;
